import './App.scss';
import { Canvas } from "@react-three/fiber";
import { Environment, OrbitControls, Plane, Loader } from "@react-three/drei";
import Model from './Turret_v02';
import { Suspense, useState } from 'react';
import * as THREE from "three"
import { FormControl, InputLabel, MenuItem, Select, Button, ThemeProvider, createTheme } from '@mui/material';

function App() {
  // const hintStyle = useSpring({
  //   from: {opacity: 0},
  //   to: {opacity: 0.8},
  //   loop: { reverse: true },
  //   config: {duration: 2000},
  //   delay: 1000,
  // })

  const [index, setIndex] = useState(1)
  const [isPaused, setPaused] = useState(false)

  const theme = createTheme({
    palette: {
      primary: {
        main: "#6798c0"
      }
    }
  })

  const handleChange = (event) => {
    setIndex(event.target.value)
    setPaused(false)
  }

  return (
    <div className="main">
      <div className='app_title'>
        <h1>Turret</h1>

        <p>from game <span>&quot;Valorant&quot;</span>with <span>Blender</span></p>

        {/* <animated.p style={hintStyle} className='hint'>
          Click to change animation.
        </animated.p> */}
      </div>

      <ThemeProvider theme={theme}>
        <div className="controls">
          <h2>Controls</h2>
  
          <FormControl className="control anim_select">
            <InputLabel>Animations</InputLabel>
  
            <Select 
              value={index} 
              onChange={handleChange}
              label="Animations"
            >
              <MenuItem value={1}>Idle</MenuItem>
              <MenuItem value={2}>Search</MenuItem>
              <MenuItem value={3}>Shoot</MenuItem>
            </Select>
          </FormControl>
  
          <Button 
            className="control" 
            fullWidth
            variant="contained"
            onClick={() => setPaused(prev => !prev)}
          >
            Play & Pause
          </Button>
  
          <Button 
            className="control" 
            fullWidth
            variant="contained"
            onClick={() => window.location.reload()}
          >
            Reload
          </Button>
        </div>
      </ThemeProvider>

      <Canvas
        shadows
        camera={{position: [-5, 5, 7]}}
        onCreated={({gl}) => {
          gl.physicallyCorrectLights = true
          gl.outputEncoding = THREE.sRGBEncoding
          gl.toneMapping = THREE.ACESFilmicToneMapping
          gl.toneMappingExposure = 1
        }}
      >
        <color attach={"background"} args={["LightGoldenrodYellow"]} />

        <ambientLight intensity={.5} />
        <pointLight
          position={[10, 25, 10]}
          castShadow
          shadow-mapSize={[1024, 1024]}
        />

        <OrbitControls
          maxPolarAngle={Math.PI / 2}
        />

        <Environment files={"/dreifaltigkeitsberg_2k.hdr"} />

        <Suspense fallback={null}>
          <Model 
            scale={0.5} 
            position={[0, -2, 0]} 
            index={index} 
            isPaused={isPaused}
          />
  
          <Plane
            args={[100, 100]}
            position={[0, -2, 0]}
            rotation={[-Math.PI/ 2, 0, 0]}
            receiveShadow
          >
            <shadowMaterial opacity={0.3} />
          </Plane>
        </Suspense>

      </Canvas>
      <Loader />
    </div>
  );
}

export default App;
